import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private mobile: boolean;
  private mobileOpen = false;

  constructor() {
    this.mobile = window.innerWidth < 768;
  }

  updateViewport(width: number): void {
    const wasMobile = this.mobile;
    this.mobile = width < 768;

    if (this.mobile !== wasMobile || !this.mobile) {
      this.mobileOpen = false;
    }
  }

  toggleMobileNavigation(): void {
    if (!this.mobile) return;
    this.mobileOpen = !this.mobileOpen;
  }

  setMobileNavigationOpen(open: boolean): void {
    this.mobileOpen = this.mobile && open;
  }

  closeMobileNavigation(): void {
    this.mobileOpen = false;
  }

  get isMobile(): boolean {
    return this.mobile;
  }

  get isMobileNavigationOpen(): boolean {
    return this.mobileOpen;
  }
}
